import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
    mode: "history",
    routes: [
        {path: '/process', name: 'process', component: () => import(/* webpackChunkName: "process" */ '../views/Process.vue')},
        {path: '/ui/process', name: 'processUIPath', component: () => import(/* webpackChunkName: "processUIPath" */ '../views/Process.vue')},
        {path: '/callback', name: 'callback', component: () => import(/* webpackChunkName: "callback" */ '../views/Callback.vue')},
        {path: '/ui/callback', name: 'callbackUIPath', component: () => import(/* webpackChunkName: "callbackUIPath" */ '../views/Callback.vue')},
        {path: '/simulate', name: 'simulate', component: () => import(/* webpackChunkName: "simulate" */ '../views/Simulate.vue')},
        {path: '/error', name: 'error', component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue')},
        {path: '/ui/error', name: 'errorUIPath', component: () => import(/* webpackChunkName: "errorUIPath" */ '../views/Error.vue')}
    ]
})
